import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

function AsyncStripeProvider({ apiKey, children }) {
  const stripePromise = loadStripe(apiKey);
  return <Elements stripe={stripePromise}>{children} </Elements>
}

export default AsyncStripeProvider;